import * as studentLessonTypes from "Store/students/studentsLessons/constants";

export const handleUpdateStudentLessonProblemFlagStatus = (
  payload: UpdateStudentLessonProblemFlagStatusPayload
): studentLessonTypes.IHandleUpdateStudentLessonProblemFlagStatus => ({
  type: studentLessonTypes.HANDLE_UPDATE_STUDENT_LESSON_PROBLEM_FLAG_STATUS,
  payload
});

export const setStudentLessonProblemFlag = (
  payload: UpdateStudentLessonProblemFlagStatusPayload
): studentLessonTypes.ISetStudentLessonProblemFlag => ({
  type: studentLessonTypes.SET_STUDENT_LESSON_PROBLEM_FLAG,
  payload
});

/**
 * ===================== REFACTORED =============================
 * */

export const setStudentActiveLesson = (payload): studentLessonTypes.ISetStudentActiveLesson => ({
  type: studentLessonTypes.SET_STUDENT_ACTIVE_LESSON,
  payload
});

export const setStudentLessonList = (payload: Lesson[]): studentLessonTypes.ISetStudentLessons => ({
  type: studentLessonTypes.SET_STUDENT_LESSONS,
  payload
});

export const handleAssignLessonsToStudent = (
  payload: AssignLessonsStudentRequest,
  fromList: boolean = false
): studentLessonTypes.IHandleAssignLessonsToStudent => ({
  type: studentLessonTypes.HANDLE_ASSIGN_LESSONS_TO_STUDENT,
  payload,
  fromList
});

export const handleRescheduleLessons = (
  payload: {
    student_lessons: string[];
    student_id: string;
  },
  fromList: boolean = false
): studentLessonTypes.IHandleRescheduleLessons => ({
  type: studentLessonTypes.HANDLE_RESCHEDULE_LESSONS,
  payload,
  fromList
});

/** @params: payload === student id */
export const handleFetchStudentLessons = (
  payload?: string
): studentLessonTypes.IHandleFetchStudentLessons => ({
  type: studentLessonTypes.HANDLE_FETCH_STUDENT_LESSONS,
  payload
});

export const handleExcuseStudentLessonLateness = (
  payload: ExcuseLessonsRequest
): studentLessonTypes.IHandleExcuseStudentLessonLateness => ({
  type: studentLessonTypes.HANDLE_EXCUSE_STUDENT_LESSON_LATENESS,
  payload
});

export const handleMarkStudentLessonsFlagsReviewed = (
  payload: StudentLessonsRequest
): studentLessonTypes.IHandleMarkStudentLessonsFlagsReviewed => ({
  type: studentLessonTypes.HANDLE_MARK_STUDENT_LESSONS_FLAGS_REVIEWED,
  payload
});
export const handleResetStudentLessons = (
  payload: StudentLessonsRequest
): studentLessonTypes.IHandleResetStudentLessons => ({
  type: studentLessonTypes.HANDLE_RESET_STUDENT_LESSONS,
  payload
});
export const handleUnassignStudentLessons = (
  payload: StudentLessonsRequest
): studentLessonTypes.IHandleUnassignStudentLessons => ({
  type: studentLessonTypes.HANDLE_UNASSIGN_STUDENT_LESSONS,
  payload
});

export const submitLessonProblems = (
  payload: SubmitStudentLessonProblemsRequest
): studentLessonTypes.IHandleSubmitStudentLessonProblems => ({
  type: studentLessonTypes.HANDLE_SUBMIT_STUDENT_LESSON_PROBLEMS,
  payload
});

export const handleFetchStudentCalendarLessons =
  (): studentLessonTypes.IHandleFetchStudentCalendarLessons => ({
    type: studentLessonTypes.HANDLE_FETCH_STUDENT_CALENDAR_LESSONS
  });

export const handleStartStudentLessonSection = (
  payload: StartLessonSectionPayload
): studentLessonTypes.IHandleStartStudentLessonSection => ({
  type: studentLessonTypes.HANDLE_START_STUDENT_LESSON_SECTION,
  payload
});
